const BASE_CLASS = 'wells-circle';
const BASE_CLASS_WAPPER = `${BASE_CLASS}__wrapper`;

export const getCircleClassNames = (well, borderConfig, condensed) => {
  let wrapperClassName = `${BASE_CLASS}__wrapper`;
  let circleClassName = BASE_CLASS;

  if (well.isValid === null) {
    circleClassName += ` ${BASE_CLASS}--disabled`;
  }

  if (condensed) {
    circleClassName += ` ${BASE_CLASS}--condensed`;
  }

  if (well && well.isValid) {
    circleClassName += ` ${BASE_CLASS}--success`;
  }

  if (well && !well.isValid && well.isValid !== null) {
    circleClassName += ` ${BASE_CLASS}--error`;
  }

  if (borderConfig.top) {
    wrapperClassName += ` ${BASE_CLASS_WAPPER}--top`;
  }

  if (borderConfig.right) {
    wrapperClassName += ` ${BASE_CLASS_WAPPER}--right`;
  }

  if (borderConfig.bottom) {
    wrapperClassName += ` ${BASE_CLASS_WAPPER}--bottom`;
  }

  if (borderConfig.left) {
    wrapperClassName += ` ${BASE_CLASS_WAPPER}--left`;
  }

  return { wrapper: wrapperClassName, circle: circleClassName };
};
